const moniteTheme = {
  colors: {
    primary: '#111111'
  }
};

export default moniteTheme;
